export const administration = [
    {
        header: 'Нур-Султан',
        codName: [
            {
                id: 1,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 2,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Алматы',
        codName: [
            {
                id: 3,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 4,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Шымкент',
        codName: [
            {
                id: 5,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 6,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Абайская область',
        codName: [
            {
                id: 7,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 8,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Акмолинская область',
        codName: [
            {
                id: 9,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 10,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Актюбинская область',
        codName: [
            {
                id: 11,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 12,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Алматинская область',
        codName: [
            {
                id: 13,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 14,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Атырауская область',
        codName: [
            {
                id: 15,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 16,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Западно-Казахстанская область',
        codName: [
            {
                id: 17,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 18,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Жамбылская область',
        codName: [
            {
                id: 19,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 20,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Жетысуская область',
        codName: [
            {
                id: 21,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 22,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Карагандинская область',
        codName: [
            {
                id: 23,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 24,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Костанайская область',
        codName: [
            {
                id: 25,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 26,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Кызылординская область',
        codName: [
            {
                id: 27,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 28,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Мангистауская область',
        codName: [
            {
                id: 29,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 30,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Туркестанская область',
        codName: [
            {
                id: 31,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 32,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Павлодарская область',
        codName: [
            {
                id: 33,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 34,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Северо-Казахстанская область',
        codName: [
            {
                id: 35,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 36,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Улытауская область',
        codName: [
            {
                id: 37,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 38,
                name: 'Городской центр обработки данных'
            }
        ]
    },
    {
        header: 'Восточно-Казахстанская область',
        codName: [
            {
                id: 39,
                name: 'Национальный центр обработки данных'
            },
            {
                id: 40,
                name: 'Городской центр обработки данных'
            }
        ]
    },
]